__turbopack_context__.v({
  "draggable": "marquee-module__irIMSq__draggable",
  "dragging": "marquee-module__irIMSq__dragging",
  "inner": "marquee-module__irIMSq__inner",
  "marquee": "marquee-module__irIMSq__marquee",
});
